<span class="favourite" [class.selected]="toggleClass" [class.disabled]="disabled" (click)="setToggle($event)">
    <vn-icon name="theme-favorite-star-multicolor" [size]="favIconSize()" />
</span>
